document.addEventListener('DOMContentLoaded', function() {
  function cleanSortOptions() {
    const dropdown = document.querySelector('.jdgm-sort-dropdown');
    if (!dropdown) return false;

    dropdown.querySelectorAll('option').forEach(option => {
      if (!['most-recent', 'highest-rating', 'lowest-rating', 'with-pictures'].includes(option.value)) {
        option.remove();
      }
    });

    return true;
  }

  // Try once immediately
  if (cleanSortOptions()) return;

  // Poll for up to 10 seconds waiting for Judge.me to render
  let attempts = 0;
  const maxAttempts = 20;
  const interval = setInterval(() => {
    if (cleanSortOptions() || ++attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 500);

  // Also observe for dynamic widget insertion (keeps working after page interactions)
  const observer = new MutationObserver(() => {
    cleanSortOptions();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});